import {z} from 'zod';

const BUILD = z.string().min(1);

export const BuildEnvsSchema = z.object({
	NODE_ENV: z
		.enum(['development', 'production'])
		.optional()
		.default('production'),
	BUILD,
});

export const ClientEnvsSchema = z.object({
	APP_PREFIX: z
		.string()
		.startsWith('/', {message: 'Must have leading and trailing slashes!!'})
		.endsWith('/', {message: 'Must have leading and trailing slashes!!'}),
	BUILD,
	FRESHDESK_SERVICE_URL: z.string().url(),
	SERVICE_ORGANIZATION_URL: z.string(),
});

export const DevEnvsSchema = z.object({
	DEV_SERVER_PORT: z
		.union([z.string(), z.number()])
		.transform(Number)
		.default(3398),
	DEV_SERVER_ALLOWED_HOSTS: z
		.string()
		.optional()
		.transform((v) => v?.split(',')?.map((s) => s?.trim())),
	DEV_SERVER_HOST: z.string().ip().optional().default('0.0.0.0'),
});

export type BuildEnvs = z.infer<typeof BuildEnvsSchema>;
export type ClientEnvs = z.infer<typeof ClientEnvsSchema>;
export type DevEnvs = z.infer<typeof DevEnvsSchema>;
